const inBrowser = typeof window !== 'undefined';

const on = (function() {
  if (!inBrowser) {
    return;
  }

  if (document.addEventListener) {
    return function(event, handler, element) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(event, handler, element) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})()

const off = (function() {
  if (!inBrowser) {
    return;
  }

  if (document.removeEventListener) {
    return function(event, handler, element) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(event, handler, element) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})()

const preventDefault = (event) => {
  event.preventDefault();               
  event.stopPropagation();
}

const touchDisable = () => {
  if (!inBrowser) {
    return;
  }

  document.documentElement.addEventListener('touchmove', preventDefault, { passive: false });
}

const touchEable = () => {
  if (!inBrowser) {
    return;
  }
  
  document.documentElement.removeEventListener('touchmove', preventDefault);
}

const m = {
  on,
  off,
  touchDisable,
  touchEable
}

module.exports = m;